<style>.kundo-knowledge-widget__button {
    bottom: 4em !important;
}</style>
<template><span></span></template>
<script>export default {
    mounted() {
    	let kundoScript = document.createElement('script');
        kundoScript.setAttribute('async', 'async');
        kundoScript.setAttribute('defer', 'defer');
        kundoScript.setAttribute('src', 'https://h54.kb.kundo.se/js/kundo-knowledge-widget.js');
        document.body.appendChild(kundoScript);
    }
}</script>